export const paymentAccounts = {
  // Stripe und Wompi sind ZWEI Integrationen, nicht zwei Varianten
  // einer: jede hat ihren Bildschirm und ihren Kopf. `tagline` ist die
  // Zeile, die einordnet (wo sie kassiert und mit welchen Mitteln).
  header: {
    stripe: {
      title: "Zahlungen mit Stripe",
      tagline: "Internationale Karten · Spanien und die meisten Länder",
      description:
        "Verbinde ein oder mehrere Stripe-Konten und lege fest, über welches jedes Inserat kassiert.",
    },
    wompi: {
      title: "Zahlungen mit Wompi",
      tagline: "Kolumbien · PSE, Nequi und kolumbianische Karten",
      description:
        "Verbinde ein oder mehrere Wompi-Konten und lege fest, über welches jedes Inserat kassiert.",
    },
    bold: {
      title: "Zahlungen mit Bold",
      tagline: "Kolumbien und Peru · PSE, Nequi, Bancolombia und Karten",
      description:
        "Verbinde ein oder mehrere Bold-Konten und lege fest, welches jede Anzeige abrechnet.",
    },
    redsys: {
      title: "Zahlungen mit Redsys",
      tagline: "Spanien · Das virtuelle POS-Terminal Ihrer Bank",
      description:
        "Verbinden Sie das virtuelle POS-Terminal Ihrer Bank und legen Sie fest, über welches Konto jedes Inserat kassiert. Das Geld geht direkt auf Ihr Bankkonto.",
      card: "Virtuelles POS-Terminal Ihrer Bank (Spanien)",
    },
  },

  // Wompi dort, wo es nicht passt. Über die Zahlart entscheidet das
  // Land des INSERATS, nicht das des Eigentümers: deshalb geht es hier
  // um Unterkünfte, nicht um dich.
  notAvailable: {
    title: "Wompi ist für Unterkünfte in Kolumbien",
    text: "Wompi kassiert in kolumbianischen Pesos über PSE, Nequi und kolumbianische Karten. Du hast dort keine Unterkunft, also gibt es hier nichts zu verbinden.",
    hint: "Sobald du eine Unterkunft in Kolumbien einstellst, öffnet sich dieser Bildschirm von selbst.",
    button: "Zu {provider}",
  },

  session: {
    title: "Deine Sitzung ist abgelaufen",
    text: "Es ist nichts verloren gegangen: Deine Zahlungskonten sind weiterhin verbunden. Melde dich erneut an, um sie zu sehen.",
    button: "Erneut anmelden",
  },

  status: {
    ready: "Bereit",
    incomplete: "Unvollständig",
    unverified: "Nicht geprüft",
  },

  environment: {
    test: "Test",
  },

  accounts: {
    card: {
      title: "Deine {provider}-Konten",
      subtitle: "Verbinde neue Konten und prüfe, ob sie bereit zum Kassieren sind.",
    },
    searchPlaceholder: "Konto nach Name suchen…",
    newButton: "{provider}-Konto verbinden",
    noName: "Ohne Namen",
    fallbackName: "Konto Nr. {id}",
    defaultBadge: "Hauptkonto",
    listingsCount: "{count} Inserat | {count} Inserate",
    empty: {
      none: "Du hast noch kein {provider}-Konto verbunden.",
      noMatch: "Kein Konto passt zur Suche.",
    },
    actions: {
      edit: "Bearbeiten",
      setDefault: "Als Hauptkonto festlegen",
      isDefault: "Ist schon das Hauptkonto",
      resume: "Anmeldung abschließen",
      verify: "Prüfen",
      disconnect: "Trennen",
    },
  },

  assign: {
    card: {
      title: "Verteilung pro Inserat",
      subtitle: "Wähle, welche Inserate jedes {provider}-Konto kassiert.",
    },
    searchPlaceholder: "Inserat nach Name suchen…",
    filter: {
      all: "Alle",
      unassigned: "Ohne Zuweisung",
      notReady: "Kassiert nicht",
      other: "Kassiert über {provider}",
    },
    // Kein Konto zugewiesen. Wenn klar ist, welches das Hauptkonto ist, wird es
    // benannt – genau das will der Gastgeber wissen: über welches Konto kassiert
    // dieses Inserat.
    autoOption: "Hauptkonto",
    autoOptionNamed: "Hauptkonto · {name}",
    autoOptionOther: "{provider}-Hauptkonto · {name}",
    otherProvider: "Kassiert über {provider} · {name}",
    otherProviderLink: "In {provider} verwalten",
    notReadyRow: "Kassiert nicht",
    notReadyRowTip: "Das Konto dieses Inserats ist noch nicht bereit, der Gast kann also nicht bezahlen.",
    notReadyAutoRow: "Dein Hauptkonto kassiert nicht",
    notReadyAutoRowTip: "Dieses Inserat nutzt das Hauptkonto, das noch nicht bereit ist. Stell es fertig oder weise dem Inserat ein anderes Konto zu.",
    notReadyBanner: "{count} Inserat kann gerade nicht kassieren: sein Konto ist noch nicht bereit. Gäste können es erst bezahlen, wenn du das Konto fertigstellst. | {count} Inserate können gerade nicht kassieren: ihr Konto ist noch nicht bereit. Gäste können sie erst bezahlen, wenn du das Konto fertigstellst.",
    notReadyBannerLink: "Diese Inserate ansehen",
    defaultSuffix: " (Hauptkonto)",
    empty: {
      none: "Du hast noch keine Inserate.",
      noMatch: "Kein Inserat passt zum Filter.",
    },
    count: "{shown} von {total} Inseraten sichtbar",
  },

  drawer: {
    newTitle: "{provider}-Konto verbinden",
    editTitle: "{provider}-Konto bearbeiten",
    subtitle: "Gib ihm einen Namen und wähle, für welche Inserate es kassiert.",
    closeAria: "Panel schließen",

    stripe: {
      title: "Anmeldung bei Stripe",
      subtitle: "Stripe fragt deine Daten ab und bringt dich danach hierher zurück.",
      explain:
        "Wir bringen dich zu Stripe, um das Konto unter diesem Namen anzulegen und deine Daten zu prüfen. Zurück hier wählst du die Inserate; brichst du die Anmeldung ab, wartet das Konto hier auf dich.",
      button: "Bei Stripe fortfahren",
      connecting: "Stripe wird geöffnet…",
      resumeTitle: "Stripe-Anmeldung unvollständig",
      resumeSubtitle: "Die Prüfung bei Stripe fehlt noch.",
      resumeExplain: "Dieses Konto wurde angelegt, hat die Anmeldung bei Stripe aber nie abgeschlossen und kann deshalb noch nicht kassieren. Mach dort weiter, wo du aufgehört hast.",
      resumeButton: "Anmeldung abschließen",
    },

    data: {
      title: "Kontodaten",
      subtitle: "Der Name ist nur für dich: er hilft dir, die Konten zu unterscheiden.",
      label: "Name des Kontos",
      labelPlaceholder: "Zum Beispiel: Apartments am Strand",
      labelHint: "Der Gast sieht ihn nie.",
      publicKey: "Öffentlicher Schlüssel",
      privateKey: "Privater Schlüssel",
      privateKeyKept: "Der bisherige bleibt erhalten",
      privateKeyHint: "Leer lassen, um den gespeicherten Schlüssel zu behalten.",
      stripeId: "Stripe-Kennung",
    },

    listings: {
      title: "Inserate dieses Kontos",
      subtitle: "Die markierten kassieren nicht mehr über ihr bisheriges Konto.",
      label: "Inserate auf diesem Konto",
      selectedCount: "{selected} von {total} markiert",
      searchPlaceholder: "Inserat suchen…",
      selectAll: "Alle auswählen",
      clear: "Leeren",
      takenBy: "aktuell bei {name}",
      noResults: "Kein Inserat passt zur Suche.",
      hint: "Inserate, die du bei keinem Konto markierst, kassieren über das Hauptkonto.",
      otherHidden: "{count} Inserat, das über {provider} kassiert, steht hier nicht: es wird auf dessen Bildschirm verwaltet. | {count} Inserate, die über {provider} kassieren, stehen hier nicht: sie werden auf dessen Bildschirm verwaltet.",
    },

    footer: {
      isDefault: "Ist schon das Hauptkonto",
      setDefault: "Als Hauptkonto festlegen",
      disconnect: "Trennen",
      cancel: "Abbrechen",
      save: "Speichern",
      saving: "Wird gespeichert…",
    },
  },

  disconnect: {
    title: "Konto trennen",
    subtitle: "Du kassierst danach nicht mehr darüber.",
    confirm:
      "Du trennst gleich „{name}“. Bereits kassierte Buchungen bleiben unberührt, aber dieses Konto nimmt keine neuen Zahlungen mehr an.",
    blocked:
      "„{name}“ kassiert noch für {count} Inserat. Vor dem Trennen muss es auf ein anderes Konto umziehen. | „{name}“ kassiert noch für {count} Inserate. Vor dem Trennen müssen sie auf ein anderes Konto umziehen.",
    moveLabel: "Diese Inserate verschieben nach",
    moveHint: "Wir verschieben sie auf das gewählte Konto und trennen danach dieses.",
    cancel: "Abbrechen",
    accept: "Trennen",
    seeListings: "Diese Inserate ansehen",
    moveAndDisconnect: "Verschieben und trennen",
  },

  loading: {
    accounts: "Deine Zahlungskonten werden geladen…",
  },

  msg: {
    loadError: "Wir konnten deine Zahlungskonten nicht laden.",
    labelRequired: "Gib dem Konto einen Namen.",
    publicKeyRequired: "Der öffentliche Wompi-Schlüssel fehlt.",
    privateKeyRequired: "Der private Wompi-Schlüssel fehlt.",
    saved: "Konto gespeichert.",
    saveError: "Wir konnten das Konto nicht speichern.",
    stripeNoUrl: "Stripe hat uns keinen Anmeldelink zurückgegeben. Versuch es noch einmal.",
    stripeConnectError: "Wir konnten die Stripe-Anmeldung nicht öffnen.",
    verified: "Das Konto ist geprüft.",
    verifiedWithName: "Konto geprüft: {name}.",
    notVerified: "Das Konto ist noch nicht geprüft. Sieh dir die Schlüssel an.",
    verifyError: "Wir konnten das Konto nicht prüfen.",
    defaultUpdated: "Das ist jetzt das Hauptkonto.",
    defaultError: "Wir konnten das Hauptkonto nicht ändern.",
    disconnected: "Konto getrennt.",
    disconnectError: "Wir konnten das Konto nicht trennen.",
    movedAndDisconnected: "Inserate verschoben und Konto getrennt.",
    savedNotReady: "Achtung: Dieses Konto kann noch nicht kassieren und hat {count} Inserat zugewiesen. Stell es fertig, sonst bleibt dieses Inserat ohne Zahlung. | Achtung: Dieses Konto kann noch nicht kassieren und hat {count} Inserate zugewiesen. Stell es fertig, sonst bleiben diese Inserate ohne Zahlung.",
    assignError: "Wir konnten das Konto dieses Inserats nicht ändern.",
  },

  integrations: {
    connectedAccounts: "{count} Konto verbunden | {count} Konten verbunden",
    notApplicable: "Für Unterkünfte in Kolumbien",
    notApplicableSpain: "Für Unterkünfte in Spanien",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "Umgebung",
    environmentHint: "Ihre Bank gibt Ihnen Zugangsdaten für Tests und andere für echte Zahlungen. Wählen Sie, zu welchen die eingegebenen gehören.",
    env: {
      test: "Test",
      prod: "Live",
    },
    merchantCode: "Händlernummer (FUC)",
    merchantCodeHint: "Sie steht in Ihrem POS-Vertrag oder im Redsys-Verwaltungsmodul. Nur Ziffern, meist neun.",
    terminal: "Terminal",
    terminalHint: "Fast immer 1. Wenn Ihre Bank Ihnen mehrere gegeben hat, das des virtuellen POS.",
    secretKey: "Signaturschlüssel (SHA-256)",
    secretKeyHint: "Im Redsys-Verwaltungsmodul → Händlerdaten → „Schlüssel anzeigen“. Wir prüfen ihn beim Speichern bei Redsys, ohne etwas abzubuchen.",
    onlyEuro: "Nur Euro · kassiert in {currency}",
    onlyEuroTip: "Redsys kassiert nur in Euro. Weisen Sie diese Unterkunft einem anderen Zahlungskonto zu.",
    msg: {
      merchantCode: "Die Händlernummer besteht nur aus Ziffern (meist neun).",
      terminal: "Das Terminal ist eine ein- bis dreistellige Zahl (fast immer 1).",
      secretKey: "Der Redsys-Signaturschlüssel fehlt.",
    },
  },
};
